import { environment } from '../../environments/environment';
import { Utility } from '../util';
import { BLocalStorageService } from './bLocalStorage.service';
var SystemService = (function () {
    function SystemService() {
        this.bLocalStorageService = new BLocalStorageService();
        this._deviceType = this.checkDevice();
        this._deviceUUID = this.checkDeviceId();
        this.properties = this.getVal('properties');
    }
    SystemService.getInstance = function () {
        if (!this.instance) {
            this.instance = new SystemService();
        }
        return this.instance;
    };
    /**
     * Returna 'mobile' or 'browser' based on the platform
     */
    SystemService.prototype.checkDevice = function () {
        if (window['device'] && (window['device']['platform'] != 'browser' || window['device']['platform'] != 'Browser')) {
            return 'mobile';
        }
        else if (window['device'] && (window['device']['platform'] == 'browser' || window['device']['platform'] == 'Browser')) {
            return 'cordova_browser';
        }
        else {
            return 'browser';
        }
    };
    SystemService.prototype.checkDeviceId = function () {
        if (this.checkDevice() === 'browser') {
            this._deviceUUID = this.bLocalStorageService.getValue('uuid');
            if (!this._deviceUUID) {
                this._deviceUUID = new Utility().generateUUID();
                this.bLocalStorageService.setValue('uuid', this._deviceUUID);
            }
        }
        else {
            this._deviceUUID = window['device'].uuid;
            this.bLocalStorageService.setValue('uuid', this._deviceUUID);
        }
        return this._deviceUUID;
    };
    Object.defineProperty(SystemService.prototype, "deviceType", {
        get: function () {
            return this._deviceType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SystemService.prototype, "deviceUUID", {
        get: function () {
            return this._deviceUUID;
        },
        enumerable: true,
        configurable: true
    });
    SystemService.prototype.getVal = function (key) {
        if (key == 'properties') {
            return environment.properties;
        }
        else {
            return environment.properties[key];
        }
    };
    SystemService.prototype.isAndroid = function () {
        if (window['device'] && window['device']['platform'] == 'Android') {
            return true;
        }
        else {
            return false;
        }
    };
    SystemService.prototype.isIOS = function () {
        if (window['device'] && window['device']['platform'] == 'iOS') {
            return true;
        }
        else {
            return false;
        }
    };
    SystemService.prototype.getAndroidVersion = function () {
        if (this.isAndroid()) {
            return window['device']['version'];
        }
        else {
            return '';
        }
    };
    SystemService.prototype.getAuthUrl = function () {
        return this.properties.baseUrl + this.properties.tenantName + '/auth/';
    };
    SystemService.prototype.getTenantUrl = function () {
        return this.properties.baseUrl + this.properties.tenantName + '/';
    };
    SystemService.prototype.getAppUrl = function () {
        return this.properties.baseUrl + this.properties.tenantName + '/proxy/' + this.properties.appName + '/';
    };
    SystemService.prototype.getProxyUrl = function () {
        return this.properties.baseUrl + this.properties.tenantName + '/proxy/';
    };
    SystemService.prototype.getDataModelUrl = function () {
        return this.properties.baseUrl + this.properties.tenantName + '/datamodel/' + this.properties.appDataSource + '/' + this.properties.appName + '/';
    };
    return SystemService;
}());
export { SystemService };



// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/service/system.service.ts.pre-build-optimizer.js